import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { otpRequest } from '../../../../../../assets/utility';
import { sendVerificationCodeStart, verifyVerificationCodeStart } from '../../../../../ngrx/auth/auth.actions';
import { selectVerifyVerificationCodeIsLoading } from '../../../../../ngrx/auth/auth.selectors';
import { BeyOtpComponent } from '../../../../shared/components/bey-otp/bey-otp.component';
import { RegistrationLayoutComponent } from '../../../../shared/components/registration-layout/registration-layout.component';

@Component({
  selector: 'app-security-verification',
  templateUrl: './security-verification.component.html',
  styleUrls: ['./security-verification.component.scss'],
  standalone: true,
  imports: [RegistrationLayoutComponent, BeyOtpComponent],
})
export class SecurityVerificationComponent implements OnInit, AfterViewInit {
  phone: string;
  currentNav: any;
  verifyVerificationCodeIsLoading$: Observable<boolean>;

  constructor(private store$: Store, public router: Router) {
    this.currentNav = this.router.getCurrentNavigation();
    if (this.currentNav?.extras?.state) {
      this.phone = this.currentNav.extras.state['phone'];
    } else {
      router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.verifyVerificationCodeIsLoading$ = this.store$.select(selectVerifyVerificationCodeIsLoading);
  }

  onChange(code: string) {
    if (code.length === 6) {
      this.store$.dispatch(
        verifyVerificationCodeStart({
          payload: {
            extras: {
              phone: this.phone,
              otp: code,
            },
            route: '/pin-reset',
          },
        })
      );
    }
  }

  onClickResend() {
    this.store$.dispatch(
      sendVerificationCodeStart({
        payload: { phone: this.phone, resetPin: true },
      })
    );
  }

  ngAfterViewInit(): void {
    otpRequest(this.onChange).catch((e) => {
      if (e instanceof DOMException && e.name == 'AbortError') {
        console.warn('WebOTP aborted');
      } else {
        console.error(e);
      }
    });
  }
}
